

// components/UserManagement.jsx
import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import 'datatables.net-dt';

// import DataTable from "datatables.net-react";
// import DT from 'datatables.net-bs5';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'bootstrap/dist/css/bootstrap.min.css';
 
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'

import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import "datatables.net-responsive-dt/css/responsive.dataTables.css";

import * as bootstrap from 'bootstrap';

 

import { getAllUsers } from "../../services/dashbboard/adminReportService";

const UserManagement = () => {
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect( () => {

    const resp =  getAllUsers().then(data=>{
        setUsers(data)
    });


  }, []);

  useEffect(() => {
    if (users.length > 0) {
      const table = $(tableRef.current).DataTable({
        destroy: true,
        data: users,
        columns: [
          { title: "شناسه", data: "identity" },
          { title: "شماره موبایل", data: "phone" },
          { title: "آخرین IP", data: "lastLoginIP" },
          {
            title: "آخرین ورود",
            data: "lastLoginDate",
            render: (data) =>
              data ? new Date(data).toLocaleString("fa-IR") : "-",
          },

           {
            title: "یادآور",
            data: "reminders",
            render: (data,type,row) =>
              row.reminders.length,
          },


           {
            title: "پرداختها",
            data: "payments",
            render: (data,type,row) =>
              row.payments.length,
          },


            {
            title: "گیاهان",
            data: "userPlants",
            render: (data,type,row) =>
              row.userPlants.length,
          },

          


          {
            title: "فعال",
            data: "isEnableAccount",
            render: (data) => (data ? "✅" : "❌"),
          },
          {
            title: "مدیر",
            data: "isAdministrator",
            render: (data) => (data ? "🛡️" : "-"),
          },
          {
            title: "عملیات",
            data: null,
            orderable: false,
            render: (data, type, row) =>
              `<button class="btn btn-sm btn-primary view-user" data-id="${row.identity}">گزارش</button>`,
          },
        ],
        responsive: true,
      });

      $(tableRef.current).on("click", ".view-user", function () {
        const identity = $(this).data("id");
        const user = users.find((u) => u.identity === identity);
        setSelectedUser(user);
        const modal = new bootstrap.Modal("#userModal");
        modal.show();
      });

      return () => {
        table.destroy(true);
      };
    }
  }, [users]);

  return (
    <div className="container">

      

      <h3>مدیریت کاربران</h3>
      <table ref={tableRef} className="table table-striped" style={{ width: "100%" }} />

      {/* Modal for User Details */}
      <div className="modal fade" id="userModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" />
              <h5 className="modal-title">گزارشات کاربر: {selectedUser?.phone}</h5>
            </div>
            <div className="modal-body">
              <ul className="nav nav-tabs" id="reportTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="plans-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#plans"
                    type="button"
                    role="tab"
                  >
                    پلن‌ کاربر
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="purchases-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#purchases"
                    type="button"
                    role="tab"
                  >
                    خریدها
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="schedules-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#schedules"
                    type="button"
                    role="tab"
                  >
                    زمان‌بندی‌ها
                  </button>
                </li>
              </ul>
              <div className="tab-content mt-3" id="reportTabsContent">
                <div className="tab-pane fade show active" id="plans" role="tabpanel">


                    <div className="credit-box">
                      <div className="credit-item">
                        <div className="credit-label">تعداد یادآور مجاز</div>
                        <div className="credit-value">{selectedUser?.maxReminder}</div>
                      </div>

                      <div className="credit-item">
                        <div className="credit-label">اعتبار حساب کاربری</div>
                        <div className="credit-value">
                          {selectedUser?.validDueDate
                            ? new Date(selectedUser.validDueDate).toLocaleDateString('fa-IR')
                            : "-"}
                        </div>
                      </div>
                    </div>



                   



                </div>
                <div className="tab-pane fade" id="purchases" role="tabpanel">
                
                
                            <div className="payments-popup">
                              <h3>لیست پرداخت‌ها</h3>
                              {selectedUser?.payments?.length ? (
                                <div className="payments-list">
                                  {selectedUser.payments.map((payment) => (
                                    <div className="payment-item" key={payment._id}>
                                      <div className="payment-row">
                                        <span className="label">مقدار:</span>
                                        <span className="value">
                                          {payment.amount.toLocaleString()} {payment.currency === 0 ? "IRR" : payment.currency === 1 ? "USD" : payment.currency === 2 ? "EUR" : "AED"}
                                        </span>
                                      </div>
                                      <div className="payment-row">
                                        <span className="label">وضعیت:</span>
                                        <span className={`value status ${payment.status}`}>{payment.status}</span>
                                      </div>
                                      <div className="payment-row">
                                        <span className="label">درگاه:</span>
                                        <span className="value">{payment.gateway}</span>
                                      </div>
                                      {payment.discount && (
                                        <div className="payment-row">
                                          <span className="label">کد تخفیف:</span>
                                          <span className="value">{payment.discount.code}</span>
                                        </div>
                                      )}
                                      <div className="payment-row">
                                        <span className="label">درخواست شده در:</span>
                                        <span className="value">{new Date(payment.requestedAt).toLocaleString('fa-IR')}</span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <p>پرداختی برای این کاربر ثبت نشده است.</p>
                              )}
                            </div>





                </div>
                <div className="tab-pane fade" id="schedules" role="tabpanel">
                
                
                                  <div className="reminders-popup">
                                    <h3>لیست یادآورها</h3>
                                    {selectedUser?.reminders?.length ? (
                                      <div className="reminders-list">
                                        {selectedUser.reminders
                                          .sort((a, b) => new Date(a.scheduledFor) - new Date(b.scheduledFor)) // مرتب بر اساس زمان
                                          .map((reminder) => (
                                          <div className="reminder-item" key={reminder._id}>
                                            <div className="reminder-row">
                                              <span className="label">گیاه:</span>
                                              <span className="value">{reminder.userPlant.nickname || reminder.userPlant._id}</span>
                                            </div>
                                            <div className="reminder-row">
                                              <span className="label">زمان یادآوری:</span>
                                              <span className="value">
                                                {new Date(reminder.scheduledFor).toLocaleString('fa-IR', { 
                                                  hour12: false, 
                                                  year: 'numeric', 
                                                  month: '2-digit', 
                                                  day: '2-digit', 
                                                  hour: '2-digit', 
                                                  minute: '2-digit' 
                                                })}
                                              </span>
                                            </div>
                                            <div className="reminder-row">
                                              <span className="label">وضعیت:</span>
                                              <span className={`value status ${reminder.status}`}>{reminder.status}</span>
                                            </div>
                                            <div className="reminder-row">
                                              <span className="label">مقدار آب:</span>
                                              <span className="value">{reminder.setting.amountPerTime} میلی‌لیتر</span>
                                            </div>
                                            <div className="reminder-row">
                                              <span className="label">تعداد دفعات در روز:</span>
                                              <span className="value">{reminder.setting.timesPerDay}</span>
                                            </div>
                                            <div className="reminder-row">
                                              <span className="label">فصل:</span>
                                              <span className="value">{reminder.setting.season}</span>
                                            </div>
                                            <div className="reminder-row">
                                              <span className="label">سایز گلدان:</span>
                                              <span className="value">{reminder.setting.potSize}</span>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <p>یادآوری‌ای برای این کاربر ثبت نشده است.</p>
                                    )}
                                  </div>




                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
